import React from "react";

const UserContext = React.createContext(); // Create a context object

export { UserContext };